import { eCategory } from "../absenceTypes-model";

// In Norway only in-lieu time (avspasering) may have zero duration —
// vacation and seniority days must not change the working time.
export function getNorwegianZeroDurationCategories(): eCategory[] {
  return [eCategory.InLieuTime];
}

// Codes for unplanned/acute absences — Norwegian institutions always run on
// the Manuel salary system, so a single list is enough.
//   SYKE = Syk med egenmelding
//   SYKL = Syk med legeerklæring
//   SYKB = Barns sykdom
const NORWEGIAN_NOT_PLANNED_CODES = ["SYKE", "SYKL", "SYKB"];

export function getNorwegianNonePlannedCodes(): string[] {
  return NORWEGIAN_NOT_PLANNED_CODES;
}
